<div *ngIf="attachment" class="btn-group m-1" role="group">
    <button type="button" class="btn btn-info" (click)="viewAttachement()" >
        <i class="fas fa-paperclip text-primary"></i> {{attachment.fileName}} <span *ngIf="shouldDisplayDate" class="badge bg-primary" >{{attachment.uploadDate | date}}</span>
    </button>
    <button type="button" class="btn btn-info" *ngIf="!attachment?.historic && isMyAttachment() && canDeleteAttachment" (click)="deleteAttachement()">
        <i class="fas fa-trash-alt" style="color: #ba1717;"></i>
      </button>
</div>
